<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing p-30">
        <Form ref="redevanceForm" @submit="genererRedevances" :validation-schema="redevanceSchema">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Commune <span class="text-danger">*</span>
                    </label>
                    <Field name="commune" v-model="communeSelect" v-slot="{ field }">
                        <Multiselect 
                        v-model="field.value" 
                        v-bind="field" 
                        :options="communesOptions" 
                        :searchable="true"
                        @change="communeChange($event)" 
                        placeholder="Rechercher une commune"
                        noResultText="Aucun enregistrement trouvé" 
                        noOptionsText="Tapez au moins caractères caractères" />
                    </Field>
                    <ErrorMessage name="commune" class="text-danger" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Agence <span class="text-danger">*</span>
                    </label>
                    <Field name="bureau" v-model="bureauselect" v-slot="{ field }">
                        <Multiselect 
                        :no-options-text="nooptions" 
                        v-model="field.value" 
                        v-bind="field" 
                        :options="bureauxOptions"
                        placeholder="Selectionner un bureau" />
                    </Field>
                    <ErrorMessage name="bureau" class="text-danger" />
                    </div>
                </div>
                
                
                <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-center">
                    <button v-if="!isloading"
                    class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                    >
                        Générer
                    </button>

                    <div v-else >
                      <div :class="(resultat.length > 0) ? 'alert alert-success':'alert alert-info'">
                        <div v-if="resultat.length == 0">Veuillez patienter. Votre requête est en cours de traitement...</div>
                        <div v-else class="mb-3 justify-content-center">
                          <center>
                            <div v-if="resultat" class="mb-2">
                              <strong>{{ resultat.message }}</strong> <br> 
                              <strong>Redevances Générées:</strong> 
                              {{ resultat?.data }}
                            </div> 
                          </center>
                        </div>
                      </div>
                      <center v-if="resultat && resultat.length != 0" >
                        <button type="button" class="btn btn-secondary py-1 px-2 m-0"
                            @click="isloading = !isloading, resultat = []"> Fermé 
                        </button>
                      </center>
                    </div>
                    
                </div>
                </div>
            </div>
        </Form>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { Redevance } from '@/models/Redevance';
import  GenererRedevanceModal  from './GenererRedevanceModal.vue';
import { success, error, format_date } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { Form, Field, ErrorMessage } from 'vee-validate';
import axios from 'axios';
import { Option } from "@/models/Option";
import Multiselect from '@vueform/multiselect'



export default defineComponent({
  name: "GenererRedevanceTempon",
  components: {
    Form,
    Field,
    Multiselect,
    ErrorMessage
},
setup: () => {

    const redevanceSchema = Yup.object().shape({
        bureau: Yup.number().typeError('Veuillez entrer un nombre').required('La valeur est obligatoire'),
        commune: Yup.number().typeError('Veuillez entrer un nombre').required('La valeur est obligatoire'),
        // annee: Yup.string().required('L\'année est obligatoire'),
    });

    

    const code = ref(null);
    const communesOptions = ref<Array<Option>>([]);
    const bureauxOptions = ref<Array<Option>>([]);
    const communeSelect = ref(null);
    const bureauselect = ref();
    const selectedQuartier = ref([]);
    const modelselect = ref();
    const boitesselect = ref();
    const arrondissementOptions = ref([]);
    const selectedArrondissement = ref([]);
    const nooptions = "La liste est vide";
    const isloading = ref(false);
    const resultat = ref([]);

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    const genererRedevances = async (value: any, redevanceForm) => {
      isloading.value = true;
        // value = value as EnvoieLotDetail;
        console.log("valueeeeeeeeee", value);
        value.estGenerer = 1;

        ApiService.get('/generationgeneration/'+value.bureau)
        .then(({ data }) => {
          if (data.code === 201) {
            console.log("yesyes",data);
              console.log("Redevances générées avec succès");
              resultat.value = data;
              success(data.message);
          }else{
              console.error("Une erreur est survenue lors de la génération");
          }
        })
        .catch((err) => {
            error(err.response.data.message);
        });
        // .finally(() => {
        //   isloading.value = false;
        // })
    };

    const fetchCommune = async () => {
      ApiService.get('/communes')
        .then(async ({ data }) => {
          const donneee = data.data.data;
          communesOptions.value = donneee.map((commune: any) => {
            return {
              label: commune.libelle,
              value: commune.id,
            };
          });
          if (JwtService.getUserCheckIfAllAgence() !== "true") {
            const element: any = await fetchAgences1(JwtService.getUserAgence());
            communeSelect.value = element.communeId;
            bureauselect.value = element.id;
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function communeChange(value) {
      if (value) {
        bureauxOptions.value = [];
        arrondissementOptions.value = [];
        selectedArrondissement.value = [];
        selectedQuartier.value = [];
        bureauselect.value = "";
        ApiService.get('/bureaux/commune/' + value)
          .then(({ data }) => {
            const donnee = data.data;
            if (donnee.length > 0) {
              bureauxOptions.value = donnee.map((bureau: any) => {
                return {
                  label: bureau.nom,
                  value: bureau.id,
                };
              });
            }
          })
          .catch(({ response }) => {
            //
          });
        ApiService.get('/communes/arrondissements/' + value)
          .then(({ data }) => {
            const donnee = data.data;
            if (donnee.length > 0) {
              arrondissementOptions.value = donnee.map((arrondissement: any) => {
                return {
                  label: arrondissement.libelle,
                  value: arrondissement.id,
                };
              });
            }
          })
          .catch(({ response }) => {
            //error(response.data.message);
          });
      } else {
        arrondissementOptions.value = [];
        selectedArrondissement.value = [];
        selectedQuartier.value = [];
        bureauselect.value = "";
      }
    }

    const fetchAgences = async (key) => {
      try {
        const response = await axios.get('/bureaus/recherche/' + key);
        const bureauxData = response.data.data;
        bureauxOptions.value = bureauxData.map((bureau) => ({
          value: bureau.id,
          label: bureau.nom,
        }));
        return bureauxOptions.value;
      } catch (error) {
        //
      }
    };

    const fetchAgences1 = async (key) => {
      try {
        const response = await axios.get(`/bureaus/${parseInt(key)}`);
        const bureau = response.data.data;
        let data = [
          {
            value: bureau.id,
            label: bureau.nom,
          }
        ];
        bureauxOptions.value = data;
        return { id: bureau.id, communeId: bureau.commune.id };
      } catch (error) {
        //
      }
    };


    onMounted( async() => {
        await fetchCommune();
        console.log("GenererRedevanceTempon mounted");
    });

  return { 
    code,
    format_date,
    redevanceSchema,
    genererRedevances,
    fetchCommune,
    fetchAgences,
    checkPermission,
    communesOptions,
    communeSelect,
    communeChange,
    bureauxOptions,
    bureauselect,
    nooptions,
    isloading,
    resultat
  };

},
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>